<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div [hidden]="!displayFirstStep">
    <mat-dialog-content>
        <mat-error *ngIf="genderFormControl.hasError('required') && genderTouched">{{ 'Field_required' | translate }}</mat-error>
        <div class="line">
            <mat-radio-group [formControl]="genderFormControl" class="flex no-space-between">
                <mat-radio-button [value]="GENDER_MALE" class="matRadio2Col">
                    {{ 'Man' | translate }}
                </mat-radio-button>
                <mat-radio-button [value]="GENDER_FEMALE" class="matRadio2Col">
                    {{ 'Woman' | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #lastnameInput
                       [required]="true"
                       [formControl]="lastnameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Lastname' | translate">
                <mat-error *ngIf="lastnameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field color="primary">
                <input matInput
                       #firstnameInput
                       [required]="true"
                       [formControl]="firstnameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Firstname' | translate">
                <mat-error *ngIf="firstnameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="accent"
                            [hintLabel]="'date_format_hint' | translate">
                <input matInput
                       #birthdayInput
                       [formControl]="birthdayFormControl"
                       [min]="birthdayMinDate"
                       [max]="birthdayMaxDate"
                       [matDatepicker]="picker"
                       [placeholder]="'Birthday' | translate">
                <mat-error *ngIf="birthdayFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="birthdayFormControl.hasError('matDatepickerMin')">{{ 'Error_min_date_x' | translate:{minDate: (utils.DateToYmdHis(birthdayMinDate) | dateClosest:'FjY')} }}</mat-error>
                <mat-error *ngIf="birthdayFormControl.hasError('matDatepickerMax')">{{ 'Error_max_date_x' | translate:{maxDate: (utils.DateToYmdHis(birthdayMaxDate) | dateClosest:'FjY')} }}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                </mat-datepicker>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #emailInput
                       [required]="true"
                       [formControl]="emailFormControl"
                       type="email"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Email_Address' | translate"
                       (keyup)="onEmailChanged()">
                <mat-error *ngIf="emailFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="emailFormControl.hasError('unavailable')">{{ 'Email_unavailable' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #billingEmailInput
                       [formControl]="billingEmailFormControl"
                       type="email"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Billing_Email_Address' | translate">
                <mat-error *ngIf="billingEmailFormControl.hasError('email')">{{ 'Email_invalid' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #streetNameInput
                       [formControl]="streetNameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Street_Name' | translate">
                <mat-error *ngIf="streetNameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field color="primary">
                <input matInput
                       #buildingNumberInput
                       [formControl]="buildingNumberFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Building_Number' | translate">
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #addressAdditionInput
                       [formControl]="addressAdditionFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Address_Addition' | translate">
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #postcodeInput
                       [formControl]="postcodeFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Postal_Code' | translate">
                <mat-error *ngIf="postcodeFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="postcodeFormControl.hasError('pattern')">{{ 'Postcode_invalid' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field color="primary">
                <input matInput
                       #cityInput
                       [formControl]="cityFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'City' | translate">
                <mat-error *ngIf="cityFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #countryInput
                       [formControl]="countryFormControl"
                       type="text"
                       maxlength="2"
                       [placeholder]="'Country' | translate">
                <mat-error *ngIf="countryFormControl.hasError('pattern')">{{ 'Country_code_invalid' | translate }}</mat-error>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #phoneNumberInput
                       [formControl]="phoneNumberFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Phone_Number' | translate">
            </mat-form-field>
        </div>
        <div class="line">
            <input-image color="primary"
                         [placeholder]="'Profile_picture'"
                         [allowedExtensions]="usersProvider.AVATAR_ALLOWED_EXTENSIONS"
                         [imageHost]="conf.storageRootUrl"
                         [maxFileSize]="usersProvider.AVATAR_MAX_SIZE"
                         [hint]="'Image_file_hint' | translate:{width: usersProvider.AVATAR_MAX_WIDTH, height: usersProvider.AVATAR_MAX_HEIGHT, size: usersProvider.AVATAR_MAX_SIZE}"
                         [(ngModel)]="avatarImage"></input-image>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button
                mat-dialog-close
                tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>
        <button mat-raised-button
                (click)="onNextClicked()"
                color="accent">
            {{ nextButtonTitle | translate}}
        </button>
    </mat-dialog-actions>
</div>

<div [hidden]="displayFirstStep">
    <mat-dialog-content>
        <div class="line">
            <mat-form-field>
                <mat-label>{{ 'athlete_size' | translate }}</mat-label>
                <input matInput
                       #sizeAthlete
                       [formControl]="sizeFormControl"
                       type="number"
                       autocomplete="off" />
                <span matSuffix>{{ 'cm' | translate }}</span>
            </mat-form-field>
        </div>
        <div class="line">
            <mat-form-field>
                <mat-label>{{ 'athlete_weight' | translate }}</mat-label>
                <input matInput
                       #weightAthlete
                       [formControl]="weightFormControl"
                       type="number"
                       autocomplete="off" />
                <span matSuffix>{{ 'Kg' | translate }}</span>
            </mat-form-field>
        </div>
        <div class="line">
            <mat-form-field color="primary">
                <input matInput
                       #sportPracticedInput
                       [formControl]="sportsPracticedFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Sport_Practiced' | translate">
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #clubInput
                       [formControl]="clubFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Club_Name' | translate">
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <input matInput
                       #clubInput
                       [formControl]="externalCoachNameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Athlete_Trainer' | translate">
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <mat-select placeholder="{{ 'Contract_Type' | translate }}"
                            [formControl]="contractTypeFormControl">
                    <mat-option *ngFor="let contractType of availableContractTypes" [value]="contractType.id">
                        {{ contractType.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <textarea matInput
                          [formControl]="athleteDescriptionFormControl"
                          class="text-area-unresizable"
                          maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                          #athleteDescriptionInput
                          cdkTextareaAutosize
                          placeholder="{{ 'Athlete_Description' | translate }}"></textarea>
                <mat-hint align="end">{{ athleteDescriptionInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button
                mat-dialog-close
                tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>
        <button mat-raised-button
                (click)="onPreviousClicked()"
                color="accent">
            {{ previousButtonTitle | translate}}
        </button>
        <button mat-raised-button
                (click)="onSaveClicked()"
                color="accent">
            {{ confirmButtonTitle | translate}}
        </button>
    </mat-dialog-actions>
</div>

<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
